import { DateInputLocalized } from '@components'

import { useCallback } from 'react'

import { useInvoiceEditorForm } from '../../../../../../../../../../../../../../contexts/invoiceEditorFormContext'
import { CommonInvoiceLineFieldProps } from '../../../../../../types/commonInvoiceLineFieldProps'

type InvoiceLineDateProps = CommonInvoiceLineFieldProps

export const InvoiceLineDate = ({ disabled = false, lineIndex }: InvoiceLineDateProps) => {
  const { invoiceEditorForm, trackInvoiceEditor } = useInvoiceEditorForm()
  const { FormItem } = invoiceEditorForm

  const handleDatePickerOpen = useCallback(() => {
    trackInvoiceEditor('Form - Invoice lines - date picker opened')
  }, [trackInvoiceEditor])

  return (
    <FormItem
      name={`invoiceLines.${lineIndex}.date`}
      render={({ field: { onChange, ...props } }) => (
        <DateInputLocalized
          {...props}
          disabled={disabled}
          onChange={(date) => {
            onChange(date)
            trackInvoiceEditor('Form - Invoice lines - date selected', {
              date,
            })
          }}
          onOpen={handleDatePickerOpen}
          showIcon={false}
          size="sm"
        />
      )}
    />
  )
}
